$(function () {
  $(
    'a[href^="#"]:not([href="#"]):not([data-toggle="tab"]):not([data-toggle="modal"]):not([data-toogle]):not([data-target]):not([data-slide])'
  ).click(function () {
    event.preventDefault();

    if (
      location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') &&
      location.hostname == this.hostname
    ) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

      if (target.length) {
        const windowWidth = $(window).width();
        let offsetModifier = 50;

        if (windowWidth > 992) {
          offsetModifier = $('#sub-nav').length ? 60 : 76;
        }

        $('html,body').animate(
          {
            scrollTop: target.offset().top - offsetModifier,
          },
          1000
        );
        return false;
      }
    }
  });
});

window.addEventListener('load', () => {
  let target = document.getElementById(location.hash.replace('#', '')) || null;

  if (target) {
    let isExpandablBlock = target.getAttribute('class') === 'expandable-block';
    let scrollTop = target.getBoundingClientRect().top + window.scrollY;

    $('html,body').animate(
      {
        scrollTop,
      },
      1000,
      'swing',
      function () {
        if (isExpandablBlock) {
          let heading = target.querySelector('.heading');
          heading.getAttribute('data-is-open') === 'false' ? target.querySelector('.heading').click() : null;
        }
      }
    );
  }
});
